<template>
  <div class="paper page-paper">
    <paper-view-lazy
      :paper-date="selectedDate"
      :key="`${this.$route.params.year}-${this.$route.params.month}-${this.$route.params.date}`"
    />
  </div>
</template>

<script>
import PaperViewLazy from "@/components/viewer/PaperViewLazy.vue";

export default {
  name: "Paper",
  data: () => ({
    today: new Date(),
  }),
  components: {
    PaperViewLazy,
  },
  computed: {
    selectedDate: function () {
      let date = `${this.$route.params.year}-${this.$route.params.month}-${this.$route.params.date}`;
      date = this.$moment(date).format();
      return new Date(date);
    },
  },
};
</script>

<style lang="scss">
.page-paper {
  margin: 0 auto;
  width: auto;
}
</style>